export const ACCOUNT_TOP_BAR_PADDING = 45;
export const PROGRAM_TOP_BAR_PADDING = 65;
// TODO we should fix the height of the program top bar instead of measuring manually
